<template>
  <div class="centerPage">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
      <el-breadcrumb-item><a href="javascript:;" @click="$router.push({path:'/doctor/reservation'})"
                             class="aHref">预约管理</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>查看详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formUserInfo">
      <div class="cnHomeTabsItem flex">
        <div v-if="reservationDetail.headImgPath" class="avatar img" :style="'backgroundImage: url('+reservationDetail.headImgPath+')'"></div>
        <div v-else class="avatar img default-user-avatar"></div>
        <div class="rightHome">
          <div class="flex">
            <span class="com">预约人：{{ reservationDetail.realName }}</span>
            <span class="com"
                  v-if="reservationDetail.consultLanguage">预约语言：{{ reservationDetail.consultLanguage }}</span>
            <span class="number">预约号：{{ reservationDetail.appointNo }}</span>
          </div>
          <div>
            <span class="time">预约时间：{{ reservationDetail.appointDateShow }} </span>
            <!--						<div><span>({{ reservationDetail.timezone + ' ' + reservationDetail.zonetime}})</span></div>-->
          </div>
          <div class="flex">
            <span class="com">咨询方式：{{ reservationDetail.consultMode === 1 ? '语音' : '视频' }}</span>
            <span class="com">咨询费用：
							<span v-if="reservationDetail.initialPayAmount != reservationDetail.payAmount"
                    class="del-line">¥{{ reservationDetail.initialPayAmount }}</span>
							<span class="cost">{{ fmtAmount(reservationDetail) }}</span>
						</span>
            <span
                :class="(reservationDetail.appointState===0&&reservationDetail.payState===0)?'orange'
                                :reservationDetail.appointState===1?'blue'
                                :reservationDetail.appointState===2?'cost'
                                :reservationDetail.appointState===3?'green'
                                :reservationDetail.appointState===4?''
                                :'cost'"
                class="com">
                            {{
                (reservationDetail.appointState === 0 && reservationDetail.payState === 0) ? '待付款'
                    : reservationDetail.appointState === 1 ? '待通话'
                    : reservationDetail.appointState === 2 ? '已取消'
                        : reservationDetail.appointState === 3 ? '待分析'
                            : reservationDetail.appointState === 4 ? '已结束'
                            : reservationDetail.appointState === 5 ? '已取消'
                                : '有问题'
              }}
                        </span>
            <div class="right">
              <!--                            <el-button size="mini" class="solid" v-if="reservationDetail.appointState===0" @click="cancelAppointMethod(reservationDetail.id)">取消预约</el-button>-->
              <el-button size="mini" class="solid" v-if="reservationDetail.appointState===1"
                         @click="toChat(reservationDetail)">前往通话
              </el-button>
              <el-button size="mini" class="solid error" v-if="reservationDetail.appointState===1"
                         @click="finishChat(reservationDetail)">结束通话
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="cnHomeTabsItem ">
        <p class="infoTit">预约信息</p>
        <div class="appointInfo">
          <p style="width: unset"><span>预约时间：</span>{{ reservationDetail.appointDateShow }}</p>
          <p><span>咨询方式：</span>{{ reservationDetail.consultMode === 1 ? '语音' : '视频' }}</p>
          <div class="flex">
            <p><span>真实姓名：</span>{{ reservationDetail.realName }}</p>
            <p><span>年龄：</span>{{ reservationDetail.age }}</p>
            <p><span>性别：</span>{{ reservationDetail.gender == 1 ? '男' : reservationDetail.gender == 0 ? '女' :'-' }}</p>
          </div>
          <div class="flex">
            <p><span>所在城市：</span>{{ reservationDetail.abodeCity }}</p>
            <p><span>职业：</span>{{ reservationDetail.occupation }}</p>
          </div>
          <!--<div class="flex">
              <p><span>手机号码：</span>{{reservationDetail.mobile}}</p>
              <p><span>邮箱账号：</span>{{reservationDetail.email}}</p>
          </div>-->
          <p class="text"><span>问题描述：</span><span>{{ reservationDetail.problemDesc }}</span></p>
          <p class="text"><span>期望效果：</span><span>{{ reservationDetail.expectEffect }}</span></p>
        </div>
      </div>
      <div class="cnHomeTabsItem" v-if="appointFileList.length !== 0">
        <p class="infoTit">附件</p>
        <div class="appointInfo" style="padding-left: 30px;">
          <p v-for="appointFile in appointFileList" :key="appointFile.id" class="attachedFile">
            <a href="javascript:void(0)" @click="downloadFile(appointFile.id)">{{ appointFile.fileName }}
              <span>下载</span></a>
          </p>
        </div>
      </div>
      <div class="cnHomeTabsItem " v-if="reservationDetail.appointState===4">
        <p class="infoTit">咨询建议</p>
        <div class="appointInfo">
          <p><span>咨询建议：</span>{{ diagnosis.result }}</p>
          <p class="text"><span>医生建议：</span><span>{{ diagnosis.adviseWritten }}</span></p>
          <p><span>用药建议：</span>{{ diagnosis.adviseDrug }}</p>
          <p>
            <span>医从性：</span>
            {{ diagnosis.patientCompliance == '1' ? '完全依从' : diagnosis.patientCompliance == '2' ? '部分依从' : '完全不依从' }}
          </p>
          <p><span>建议医院：</span>{{ diagnosis.adviseHospital }}</p>
          <p><span>建议医师：</span>{{ diagnosis.adviseDoctor }}</p>
          <p><span>备注：</span>{{ diagnosis.doctorRemark }}</p>
        </div>
      </div>

      <div class="cnHomeTabsItem " v-if="reservationDetail.appointState===3">
        <p class="infoTit">咨询建议填写</p>
        <el-form ref="form" :model="diagnosis" label-width="120px" class="appointInfo" label-suffix="：">
          <el-form-item label="咨询建议">
            <el-input v-model="diagnosis.result" placeholder="请输入咨询建议"></el-input>
          </el-form-item>
          <el-form-item label="医生建议">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5}"
                placeholder="请输入医生建议"
                v-model="diagnosis.adviseWritten">
            </el-input>
          </el-form-item>
          <el-form-item label="用药建议">
            <el-input v-model="diagnosis.adviseDrug" placeholder="请输入用药建议"></el-input>
          </el-form-item>
          <el-form-item label="依从性">
            <el-radio-group
                v-model="diagnosis.patientCompliance"
                size="small"
                fill="#567BFF">
              <el-radio-button label="1" type="success">完全依从</el-radio-button>
              <el-radio-button label="2">部分依从</el-radio-button>
              <el-radio-button label="3">完全不依从</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="建议医院">
            <el-input v-model="diagnosis.adviseHospital" placeholder="请输入医院名称"></el-input>
          </el-form-item>
          <el-form-item label="建议医生">
            <el-input v-model="diagnosis.adviseDoctor" placeholder="请输入医生姓名"></el-input>
          </el-form-item>
          <div class="flex">
            <el-form-item label="备注">
              <el-input v-model="diagnosis.doctorRemark" placeholder="备注"></el-input>
            </el-form-item>
            <el-button type="primary" @click="onSubmit">提交意见</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import commonjs from "../../api/common";

export default {
  name: "reservationDetail",
  data() {
    return {
      reservationDetail: {},//预约详情数据
      no: this.$route.query.no,
      diagnosis: {
        appointId: '',//预约id
        result: '',//咨询结果
        adviseWritten: "",//医生建议
        patientCompliance: "1",//依从性
        adviseHospital: "",//实体医院推荐
        adviseDoctor: "",//线下医生推荐
        doctorRemark: "",//医生备注
        adviseDrug: "",//用药建议
      },

      detailData: {},//预约详情数据

      appointCancelCondition: {
        eventId: '',//appointNo
        reason: '',//原因
      }, //取消预约

      appointFileList: [],
    }
  },
  async mounted() {
    this.getDetail()
  },
  methods: {
    onSubmit() {
      this.diagnosis.appointId = this.reservationDetail.id;
      let that = this;
      this.$ajax.post(commonjs.api.doctor.reservation.createRecord.replace('{id}', this.diagnosis.appointId), that.diagnosis).then(res => {
        if (res.data.status === 'success') {
          that.$message.success("提交成功");
          that.reservationDetail.appointState = 4;
        } else {
          that.$message.error(res.data.message);
        }
        // that.getDetail()
      }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    getDetail() { //获得预约详情
      let that = this;
      this.$ajax
          .get(commonjs.api.doctor.reservation.detailByNoDoctor.replace("{appointNo}", that.no))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.reservationDetail = res.data.data || {};
              that.reservationDetail.appointDateShow = commonjs.utils.buildShowDate(that.reservationDetail.appointStartLongtime, that.reservationDetail.appointEndLongtime);
              if (that.reservationDetail.appointState === 4) {
                that.getRecordMethod()
              }
              // 加载附件信息
              let id = res.data.data.id;
              if (!id) {
                return;
              }
              that.$ajax.get(commonjs.basePath + 'medical/medical-appoint-file/authorize/list/' + id).then(res1 => {
                if (res1.data.status === 'success') {
                  that.appointFileList = res1.data.list;
                }
              })
            } else {
              that.$message.error('信息加载失败');
            }
          })
    },
    getRecordMethod() { //查找咨询结果
      let that = this;
      this.$ajax
          .get(commonjs.api.doctor.medicalRecord.recordDoctorByMedical.replace("{medicalNo}", that.reservationDetail.medicalNo))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.diagnosis = res.data.data.medicalRecord;
            }
          })
    },
    toChat(obj) {
      this.$router.push({path: '/chat/doctors/' + obj.id, query: {userDetail: obj}})
      // this.$router.push('/chat/doctors/' + id)
    },
    cancelAppointMethod(id) { //取消预约
      this.appointCancelCondition.eventId = id;
      let that = this;
      this.$prompt('请输入原因', '取消预约', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
      }).then(({value}) => {
        this.appointCancelCondition.reason = value;
        this.$ajax
            .post(commonjs.api.doctor.reservation.appointCancel, that.appointCancelCondition)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('取消成功');
              } else {
                that.$message.error('取消失败');
              }
              that.pageAppoint();
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      });
    },
    downloadFile(fileId) {
      this.$ajax.post(commonjs.api.upload.token.appoint.replace("{id}", fileId)).then(res => {
        if (res.data.status === 'success') {
          location.href = commonjs.api.upload.download.token.replace("{token}", res.data.token);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('获取文件失败');
      })
    },
    finishChat(item) {
      let that = this;
      that.$messageBox.confirm('确定要结束此预约吗吗?', '结束确认', {type: 'warning'}).then(() => {
        that.$ajax.post(commonjs.basePath + 'medical/medical-appoint/authorize/finish/' + item.id).then(res => {
          if (res.data.status === 'success') {
            item.appointState = 3;
            that.$message.success('修改成功');
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('操作失败');
        });
      });
    },
    fmtAmount(item) {
      if (item.couponType == 0) {
        return '¥' + item.payAmount;
      } else if (item.couponType == 1) {
        return '¥' + item.payAmount;
      } else if (item.couponType == 2) {
        if (item.payAmount == 0) {
          return '月卡支付';
        } else {
          return '¥' + item.payAmount + ' 月卡抵扣';
        }
      } else if (item.couponType == 3) {
        if (item.payAmount == 0) {
          return '年卡支付';
        } else {
          return '¥' + item.payAmount + ' 年卡抵扣';
        }
      } else {
        return '-';
      }
    }
  },
  filters: {
    appointTime: function (appointDate, appointTimeSlot) {
      //appointDate: 2020-08-24T00:00:00
      //appointTimeSlot: 20 即二十点到二十一点
      appointDate = new Date(appointDate).Format('yyyy年MM月dd日');
      return appointDate + appointTimeSlot + '至' + (appointTimeSlot + 1) + '时';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.centerPage {
  display: block;

  .orange {
    color: #FFAB37;
  }
}

.cnHomeTabsItem .rightHome .flex {
  justify-content: inherit;

  span.com {
    width: 27%;
  }

  .number {
    text-align: right;
    width: 46%;
  }
}

.right {
  width: 19%;
  margin: 0;
  text-align: right;
}

p.attachedFile {
  width: 90%;

  a {
    color: #303139;

    span {
      color: #4395FF;
      margin-left: 10px;
      font-weight: 700;
      width: unset;
    }
  }
}

.cnHomeTabsItem {
  padding: 20px;
}

span.del-line {
  color: #FC7B66;
  text-decoration: line-through;
  margin-right: 8px;
}

.default-user-avatar {
  background: url("/static/default_imgs/avatar.png") no-repeat;
  background-size: contain;
}
</style>
